import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCameraRetro,
  faDragon,
  faFootballBall,
  faGlassCheers,
  faHelicopter
} from "@fortawesome/free-solid-svg-icons";

import sriLankaMap from "../assets/sri_lanka_map.png";
import { none } from "ol/centerconstraint";

export default [
  {
    id: 1,
    bgColor: "#800000",
    image: <img src={sriLankaMap} width={"82px"} height={"82px"}/>,
    icon: <FontAwesomeIcon icon={faCameraRetro} size="3x" />,
    title: "Lorem Ipsum",
    desc:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s."
  },
  {
    id: 2,
    bgColor: "#9A6324",
    image: <img src="" width={"82px"} height={"82px"}/>,
    icon: <FontAwesomeIcon icon={faGlassCheers} size="3x" />,
    title: "Lorem Ipsum",
    desc:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s."
  },
  {
    id: 3,
    bgColor: "#808000",
    image: <img src="" width={"82px"} height={"82px"}/>,
    icon: <FontAwesomeIcon icon={faDragon} size="3x" />,
    title: "Lorem Ipsum",
    desc:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s."
  },
  {
    id: 4,
    bgColor: "#469990",
    image: <img src="" width={"82px"} height={"82px"}/>,
    icon: <FontAwesomeIcon icon={faFootballBall} size="3x" />,
    title: "Lorem Ipsum",
    desc:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s."
  },
  {
    id: 5,
    bgColor: "#e6194B",
    image: <img src={sriLankaMap} width={"82px"} height={"82px"}/>,
    icon: <FontAwesomeIcon icon={faHelicopter} size="3x" />,
    title: "Lorem Ipsum",
    desc:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s."
  },{
    id: 6,
    bgColor: "#f58231",
    image: <img src={"sriLankaMap"} width={"82px"} height={"82px"}/>,
    icon: <FontAwesomeIcon icon={faDragon} size="3x" />,
    title: "Lorem Ipsum",
    desc:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s."
  },
  {
    id: 7,
    bgColor: "#ffe119",
    image: <img src="" width={"82px"} height={"82px"}/>,
    icon: <FontAwesomeIcon icon={faGlassCheers} size="3x" />,
    title: "Lorem Ipsum",
    desc:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s."
  },
  {
    id: 8,
    bgColor: "#bfef45",
    image: <img src="" width={"82px"} height={"82px"}/>,
    icon: <FontAwesomeIcon icon={faFootballBall} size="3x" />,
    title: "Lorem Ipsum",
    desc:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s."
  },
  {
    id: 9,
    bgColor: "#3cb44b",
    image: <img src={sriLankaMap} width={"82px"} height={"82px"}/>,
    icon: <FontAwesomeIcon icon={faHelicopter} size="3x" />,
    title: "Lorem Ipsum",
    desc:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s."
  },
  {
    id: 10,
    bgColor: "#42d4f4",
    image: <img src="" width={"82px"} height={"82px"}/>,
    icon: <FontAwesomeIcon icon={faHelicopter} size="3x" />,
    title: "Lorem Ipsum",
    desc:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s."
  },{
    id: 11,
    bgColor: "#911eb4",
    image: <img src="" width={"82px"} height={"82px"}/>,
    icon: <FontAwesomeIcon icon={faDragon} size="3x" />,
    title: "Lorem Ipsum",
    desc:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s."
  },
  {
    id: 12,
    bgColor: "#f032e6",
    image: <img src="" width={"82px"} height={"82px"}/>,
    icon: <FontAwesomeIcon icon={faHelicopter} size="3x" />,
    title: "Lorem Ipsum",
    desc:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s."
  },{
    id: 13,
    bgColor: "#fabed4",
    image: <img src="" width={"82px"} height={"82px"}/>,
    icon: <FontAwesomeIcon icon={faDragon} size="3x" />,
    title: "Lorem Ipsum",
    desc:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s."
  }
];
